module["exports"] = [
  "Dr.",
  "Prof. Dr."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/name/prefix.js
// module id = 2003
// module chunks = 2